import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * `.empty` — round tinted icon, heading, optional one-line description and an
 * optional action. Used for every "nothing here yet" state in the mockup.
 */
export const TeacherEmptyState = ({ icon, title, description, action, dense = false, sx = {} }) => (
  <Box
    sx={{
      padding: dense ? '36px 12px' : '54px 20px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '6px',
      ...sx,
    }}
  >
    {icon && (
      <Box
        sx={{
          width: 66,
          height: 66,
          borderRadius: '50%',
          display: 'grid',
          placeItems: 'center',
          mb: '8px',
          color: 'primary.main',
          bgcolor: (t) => alpha(t.palette.primary.main, 0.13),
          '& svg': { fontSize: 26 },
        }}
      >
        {icon}
      </Box>
    )}
    <Typography component="h4" sx={{ fontSize: '16px', fontWeight: 700, color: 'text.primary' }}>
      {title}
    </Typography>
    {description && (
      <Typography sx={{ color: 'text.secondary', fontSize: '13px', maxWidth: 330 }}>
        {description}
      </Typography>
    )}
    {action && <Box sx={{ mt: '10px' }}>{action}</Box>}
  </Box>
);

/**
 * Loading counterpart to the empty state, so pages have one consistent
 * placeholder height instead of a bare centred spinner.
 */
export const TeacherLoading = ({ label = 'Loading…', sx = {} }) => (
  <Box
    sx={{
      padding: '54px 20px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '14px',
      ...sx,
    }}
  >
    <CircularProgress size={30} thickness={4} />
    <Typography sx={{ color: 'text.secondary', fontSize: '13px' }}>{label}</Typography>
  </Box>
);

export default TeacherEmptyState;
